import { __rest } from "tslib";
import { AttributeType } from '../models';
import { refineModelForRequest } from '@/client/formatters/utils';
import { getConfig } from '@/config';
import { SearchForRetail } from '@/constants';
import { BiasType } from '@/search-for-retail/models/attribute.model';
export const formatBiasingStrategy = (_a) => {
    var { areaId, defineBiasItems, copyable = true } = _a, model = __rest(_a, ["areaId", "defineBiasItems", "copyable"]);
    const config = getConfig();
    return Object.assign(Object.assign(Object.assign(Object.assign({}, refineModelForRequest(model)), { areaId, areaDefault: false, copyable }), formatDefineBiasItems(defineBiasItems)), { merchandiser: {
            merchandiserId: config.customer,
        } });
};
export const formatDefineBiasNumericContents = (numericContents) => {
    const numericContent = {
        ranges: [],
        values: [],
    };
    numericContents.forEach((content) => {
        var _a, _b;
        if ((_a = content === null || content === void 0 ? void 0 : content.ranges) === null || _a === void 0 ? void 0 : _a.length) {
            const { low, high } = content.ranges[0];
            const rangeItem = {};
            if (String(low) !== '')
                rangeItem.low = Number(low);
            if (String(high) !== '')
                rangeItem.high = Number(high);
            numericContent.ranges.push(rangeItem);
        }
        if ((_b = content === null || content === void 0 ? void 0 : content.values) === null || _b === void 0 ? void 0 : _b.length) {
            numericContent.values.push(...content.values);
        }
    });
    if (numericContent.values.length === 0)
        delete numericContent.values;
    if (numericContent.ranges.length === 0)
        delete numericContent.ranges;
    return numericContent;
};
export const formatDefineBiasItems = (defineItems) => ({
    biases: defineItems.map(({ type, matches, attributeName, numericContents, influenceSliderValue, }) => {
        const isNumeric = type === AttributeType.Numerical || type === BiasType.Numeric;
        const isTextual = type === AttributeType.Textual || type === AttributeType.Unknown;
        const BiasItem = Object.assign(Object.assign(Object.assign({ field: attributeName, strength: SearchForRetail.BiasingStrategyStrength[influenceSliderValue] }, (type && {
            type: isNumeric ? BiasType.Numeric : isTextual ? BiasType.Textual : null,
        })), ((!type || isTextual) && { content: matches })), (isNumeric && {
            numericContent: formatDefineBiasNumericContents(numericContents),
        }));
        return BiasItem;
    }),
});
